module.exports = __webpack_public_path__ + "static/media/table-grey.88f1c9ca.svg";